export const DOWNLOAD_DIMENSION_OPTIONS = [
    { value: 0, text: 'Video 1920x1080', width: '1920', height: '1080'},
    { value: 1, text: 'Instagram 1080x1080', width: '1080', height: '1080' },
    { value: 2, text: 'Instagram 1500x1500', width: '1500', height: '1500' },
    { value: 3, text: 'Instagram Story 1080x1920', width: '1080', height: '1920' },
    { value: 4, text: 'Banner Ad 300x250', width: '300', height: '250' },
    { value: 5, text: 'Banner Ad 600x500', width: '600', height: '500' },
    { value: 6, text: 'Banner Ad 728x90', width: '728', height: '90' },
    { value: 7, text: 'Banner Ad 1456x180', width: '1456', height: '180' },
    { value: 8, text: 'Video 2400x2400', width: '2400', height: '2400' },
    { value: 9, text: 'Video 1080x1920', width: '1080', height: '1920' },
    { value: 10, text: 'Player dimensions', width: '', height: '' },
    // Appended, never inserted: BtnVideoCreate indexes this array by `value`
    // (onResolutionChange) and hardcodes 10 for 'Player dimensions', and saved
    // download settings persist the number. The two 720p canvases the
    // Brief/Script modal can now create (POR-14117) otherwise had no named
    // entry and fell through to 'Player dimensions'.
    { value: 11, text: 'Video 1280x720', width: '1280', height: '720' },
    { value: 12, text: 'Video 720x1280', width: '720', height: '1280' }
]

export const VTT_VALUES = {
    NONE: 'None',
    CAPTION: 'Caption fields',
    NO_AUDIO: 'No audio',
    WITH_AUDIO: 'Music playing'
}

export const VTT_OPTIONS = [
    { value: VTT_VALUES.NONE, text: VTT_VALUES.NONE },
    { value: VTT_VALUES.CAPTION, text: VTT_VALUES.CAPTION },
    { value: VTT_VALUES.NO_AUDIO, text: VTT_VALUES.NO_AUDIO },
    { value: VTT_VALUES.WITH_AUDIO, text: VTT_VALUES.WITH_AUDIO }
]

export const A_CODEC_VALUES = {
    AAC: 'AAC',
    AC3: 'AC3',
    MP3: 'MP3'
}

export const A_CODEC_OPTIONS = [
    { value: A_CODEC_VALUES.AAC, text: A_CODEC_VALUES.AAC },
    { value: A_CODEC_VALUES.AC3, text: A_CODEC_VALUES.AC3 },
    { value: A_CODEC_VALUES.MP3, text: A_CODEC_VALUES.MP3 }
]

export const AUDIO_VALUES = {
    TRACK: 'track',
    CLIP: 'clip',
    NONE: 'none'
}

export const AUDIO_OPTIONS = [
    { value: AUDIO_VALUES.TRACK, text: 'Added audio track' },
    { value: AUDIO_VALUES.CLIP, text: 'Original clip audio' },
    { value: AUDIO_VALUES.NONE, text: 'No audio' }
]
